export function getObjectDiffMask<T extends object>(
  prev: T,
  curr: T
): Record<string, boolean> {
  const diff: Record<string, boolean> = {};
  const allKeys = new Set([
    ...Object.keys(prev || {}),
    ...Object.keys(curr || {}),
  ]);
  allKeys.forEach((key) => {
    let prevValue = (prev as any)[key];
    let currValue = (curr as any)[key];

    if (
      Array.isArray(prevValue) &&
      prevValue.length === 1 &&
      prevValue[0] === ""
    ) {
      prevValue = "";
    }
    if (
      Array.isArray(currValue) &&
      currValue.length === 1 &&
      currValue[0] === ""
    ) {
      currValue = "";
    }

    diff[key] = JSON.stringify(prevValue) !== JSON.stringify(currValue);
  });

  return diff;
}
